<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title">Crear usuario</h6>

    
    <!-- Card body -->
    <!--
    <div class="row">
      <div class="col-lg-8">
        <p class="mb-0">
          We recommend using client side validation, but in case you require server side, you can indicate invalid and valid form fields with <code>.is-invalid</code> and <code>.is-valid</code>. Note that <code>.invalid-feedback</code>
          is also supported with these classes.
        </p>
      </div>
    </div>
    <hr>
    -->
    <form class="needs-validation" id="formCreateUser"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="model.firstName">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input :label="labelRut"
                      :name="labelRut"
                      :placeholder="'Ingrese el '+labelRut+' de la persona'"
                     
                      v-model="model.dni">
          </base-input>
          <p class="small">Campo opcional</p>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Email"
                      name="email"
                      type="email"
                      placeholder="Ingrese una dirección de correo electrónico"
                      :error="getError('email')"
                      v-validate="'required|email'"
                      v-model="model.email">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sponsor" 
                v-model="model.sponsor"
                name="Sponsor"
                :error="getError('Sponsor')"
                v-validate="'required'"
                >
                    <el-select v-model="model.sponsor" filterable
                                placeholder="Seleccione Sponsor"
                                @change="updateSucursales"
                                >
                        <el-option v-for="option in selectSponsors"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sucursal"
                v-model="model.sucursal"
                name="Sucursal"
                :error="getError('Sucursal')"
                v-validate="'required'"
                >
                    <el-select v-model="model.sucursal" filterable
                                placeholder="Seleccione Sucursal"
                                @change="updateTeams"
                                >
                        <el-option v-for="option in selectSucursales"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Equipo"
                v-model="model.equipo"
                name="Equipo"
                :error="getError('Equipo')"
                v-validate="'required'"
                >
                    <el-select v-model="model.equipo" filterable
                                placeholder="Seleccione equipo">
                        <el-option v-for="option in selectOptions"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Contraseña"
                      name="contraseña"
                      type="password"
                      placeholder="Ingrese una contraseña"
                      :error="getError('password')"
                      v-validate="'required|min:6'"
                      ref="password"
                      v-model="model.password">
          </base-input>
        </div>
      </div>
      
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Confrmar contraseña"
                      name="confirmar"
                      type="password"
                      placeholder="Ingrese nuevamente la contraseña"
                      :error="getError('confirmar')"
                      v-validate="'required|min:6|confirmed:password'"
                      v-model="model.password_confirmation">
          </base-input>
        </div>
      </div>
      <!--
      <base-input>
        <base-checkbox v-model="model.agree">
          Agree to terms and conditions
        </base-checkbox>
      </base-input>
      -->
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formCreateUser">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
import { Select, Option } from 'element-ui';

  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        model: {
          firstName: '',
          email: '',
          password: '',
          password_confirmation: '',
          equipo: '',
          sucursal: '',
          sponsor: '',
          dni: ''
        },
        showModal: false,
        selectOptions: [], // Este debe ser un arreglo de objetos asi: { label: ...(es lo que se ve), value: ...}
        selectSucursales: [],
        selectSponsors: []
      }
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      updateSucursales()
      {
        var vm = this;
        this.axios({
          url: 'api/test_list_sucursales_from_create_user?sponsor='+this.model.sponsor,
          method: 'GET',
        }).then( response =>{
          vm.selectSucursales = response.data;
          if( response.data.length == 1 ){
            vm.model.sucursal = response.data[0].value;
            vm.updateTeams();
          }else{
            vm.model.sucursal = undefined;
          }
        })
        ;
      },
      updateTeams(){
        var vm = this;
        this.axios({
          url: 'api/test_list_teams_from_create_user?sucursal='+this.model.sucursal,
          method: 'GET',
        }).then( response =>{
          vm.selectOptions = response.data;
          if( response.data.length == 1 ){
            vm.model.equipo = response.data[0].value;
          }else{
            vm.model.equipo = undefined;
          }
        })
        ;
      },
      sendForm(){
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            
            vm.axios({
                method: 'POST',
                url: 'api/store_create_user',
                data: {   nombre: vm.model.firstName, 
                          equipo: vm.model.equipo,
                          email: vm.model.email,
                          contraseña: vm.model.password,
                          contraseña_confirmation: vm.model.password_confirmation,
                          sucursal: vm.model.sucursal,
                          sponsor: vm.model.sponsor,
                          dni: vm.model.dni
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Usuario creado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo almacenar el usuario',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
      }
    },
    mounted()
    {
        var vm = this;
        vm.axios({
          method: 'GET',
          url: 'api/test_list_sponsors_from_create_user'
        }).then( response => {
          vm.selectSponsors = response.data;
          if( response.data.length == 1 ){
            vm.model.sponsor = response.data[0].value;
            vm.updateSucursales();
          }
        });
        
    },
    created()
    {
      this.$parent.$on('showModalCreateUser', () => { this.showModal = true; } )
    },
    computed: {
      labelRut(){
        let pais = this.$store.state.user.pais_sponsor || '';
        switch(pais){
          case 'Chile':
            return 'RUT';
            break;
          case 'Colombia':
            return 'DNI';
            break;
          case 'Ecuador':
            return 'DNI';
            break;
          case 'Argentina':
            return 'DNI';
            break;
          default:
            return 'DNI';
            break;
        }
      }
    }
  }
</script>
<style>
</style>
